export default "__VITE_ASSET__b371ddb1__"